import type { FC } from 'react'

import { SCROLL_INDICATED_CONTENT_WRAPPER_ID } from '@features/common.components/Header/ScrollIndicator'

import { DesktopNavigation } from './desktop/DesktopNavigation'
import { MobileNavigation } from './mobile/MobileNavigation'

import type { NavigationProps } from './types'

interface NavigationPropsWithLoading extends NavigationProps {
  /**
   * Whether the navigation content is loading.
   */
  loading?: boolean
}

export const Navigation: FC<NavigationPropsWithLoading> = (props) => {
  return (
    <>
      <DesktopNavigation
        contentWrapperId={SCROLL_INDICATED_CONTENT_WRAPPER_ID}
        {...props}
      />
      <MobileNavigation
        contentWrapperId={SCROLL_INDICATED_CONTENT_WRAPPER_ID}
        {...props}
      />
    </>
  )
}
